// Copyright (C) 2017-2023 Smart code 203358507

const Image = require('./Image');

module.exports = Image;
